// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 44437 ? "0a33da26" : chunkId) + "." + {"42092":"4b0581c4d95441bc","44437":"836b78c80499e662","62896":"7e07744a0af60be4","78518":"fa8616d4372f66e4"}[chunkId] + ".js";
};